export const PaymentMethodType = {
    Unknown: 0,
    BankCard: 1,
    MeezaCard: 2,
    Wallet: 3,
    Instapay: 5,
    ApplePay: 6,
}

export const SessionStatus = {
    InProgress: 1,
    Completed: 2,
}

export const TransactionStatus = {
    InProgress: 1,
    Successful: 2,
    Failed: 3,
    Refunded: 4,
    PendingAuthentication: 5,
    Authenticated: 6
}

export const InstapayCollectionMethods = {
    QR: { code: "01", label: "QR Code" },
    IntentCall: { code: "02", label: "Intent Call" },
    CollectRequest: { code: "03", label: "Collect Request" },
    PaymentLink: { code: "04", label: "Payment Link" }
}

export const CountryCodes = {
    EGYPT: 'EG'
}


export const ApplePaySupportedNetworks = ["visa", "masterCard", "meeza"]
export const ApplePaySupportedMerchantCapabilities = ["supports3DS", "supportsDebit", "supportsCredit"]

export const DigitalWalletProviders = {
    ApplePay: 1,
    GooglePay: 2,
    SamsungPay: 3,
}